import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageManagerComponent } from './page-manager.component';
import { PageEditComponent } from './page-edit/page-edit.component';
 

const routes: Routes = [{ path: 'pages', component: PageManagerComponent },
{path:'page/:id', component: PageEditComponent},
{path:':type/page/:id', component: PageEditComponent},
// {path:'list/:type/:id', component: CoreGridComponent},


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageManagerRoutingModule { }
